import React, {Component} from 'react'
import {REASON} from "../../helpers/filterLists"
import {Select} from "antd"
import 'antd/lib/select/style/index.css'
import PropTypes from 'prop-types'

const {Option} = Select

class FilterReason extends Component {
    _handleChange = (value) => {
        const {onChangeFilters} = this.props
        const filters = Object.assign({}, this.props.filters)

        if (typeof onChangeFilters === 'function') {
            onChangeFilters({
                ...filters,
                reason: value
            })
        }
    }

    render() {
        const {filters} = this.props
        const {reason} = filters
        const field = 'reason'

        return (
            <div className="FilterShippingCarrier mb-3 mr-3">
                <label className='font-weight-bold d-block'>Lý do</label>
                <Select
                    style={{width: 300}}
                    showArrow={true}
                    placeholder="Vui lòng chọn lý do bạn muốn tìm kiếm"
                    defaultValue={reason}
                    onChange={this._handleChange}
                    value={reason}
                >
                    {
                        REASON.map((option, index) => {

                            const {name, value} = option

                            return <Option key={`${field}_${value}_${index + 1}`} value={value}>{name}</Option>
                        })
                    }
                </Select>
            </div>
        )
    }
}

FilterReason.propTypes = {
    filters: PropTypes.object.isRequired
}

export default FilterReason